import { CircularProgress, Grid } from '@material-ui/core';
import moment from 'moment';
import React, { useState } from 'react';
import { useNotify } from '../../../hooks/useNotify';
import { doSwaggerCall } from '../../../hooks/useSwaggerClient';
import PayoutReportsTable from './components/PayoutReportsTable';
import PayoutReportsFilter from './components/PayoutReportsFilter';
import { exportToXlsx } from '../../../excelExportHelpers';

const PayoutReportPage = () => {
    const { notifyError } = useNotify();
    const [filters, setFilters] = useState({
        clientId: null,
        startDate: null,
        endDate: null,
        groupActivities: false
    });
    const [loading, setLoading] = useState(false);
    const [reports, setReports] = useState({ payouts: [], grandTotal: [] });

    const generateReport = async () => {
        setLoading(true);
        doSwaggerCall('clients', 'getPayoutReport', {
            clientId: filters.clientId,
            startDate: filters.startDate ? moment(filters.startDate).format('YYYY-MM-DD') : '',
            endDate: filters.endDate ? moment(filters.endDate).format('YYYY-MM-DD') : '',
            groupActivities: filters.groupActivities
        })
            .then(({ payouts, grandTotal }) => {
                setReports({ payouts, grandTotal });
            })
            .catch(err => {
                console.log(err);
                notifyError('Could not generate payout report');
            })
            .finally(() => setLoading(false));
    };

    const exportXlsx = () => {
        if (!reports) {
            return;
        }
        exportToXlsx(
            reports?.payouts.map(e => ({
                feeName: e.feeName,
                accountTo: e.accountTo,
                agent: e.user_commission
                    ? `${e.user_commission?.firstname} ${e.user_commission?.lastname}`
                    : '-',
                activity: filters.groupActivities ? e.activity_name || '-' : undefined,
                sumNet: e.sumNet,
                sumTax: e.sumTax
            })),
            'payout_report'
        );
    };

    return (
        <Grid container className="golf-reservation">
            <PayoutReportsFilter
                filters={filters}
                setFilters={setFilters}
                generateReport={generateReport}
                exportXlsx={exportXlsx}
            />
            <Grid container item lg={9} sm={8} xs={12}>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <PayoutReportsTable
                        reports={reports}
                        loading={loading}
                        groupActivities={filters.groupActivities}
                    />
                )}
            </Grid>
        </Grid>
    );
};

export default PayoutReportPage;
